import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

const Dashboard = () => {
    return (
        <div>
            <Sidebar></Sidebar>
        </div>
    );
};

export default Dashboard;